import { createContext } from 'react';
export type StepContextType = {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
};
export const StepContext = createContext<StepContextType | undefined>(undefined);
